var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":("" + (_vm.images.src)),"srcset":_vm.images.srcSet,"title":_vm.$props.title,"alt":_vm.$props.title}})])}
var staticRenderFns = []

export { render, staticRenderFns }